export default {
    invoiceRecipient: "Rechnungsempfänger",
    chooseInvoiceRecipient: "Rechnungsempfänger auswählen",
    addDeviatingInvoiceRecipient: "Abweichenden Rechnungsempfänger verwenden",
    useBookerAsInvoiceRecipient: "Kontaktperson als Rechnungsempfänger verwenden",
    alternativeAccountHolder: "Alternative Kontoinhaber",
    iban: "IBAN",
    paymentType: "Zahlungsart",

    select: "Auswählen",
    edit: "Bearbeiten",
    ready: "Fertig",
}
